// utils/slugify.js
export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/&/g, "and")        // & => and
    .replace(/[^a-z0-9]+/g, "-") // spaces/special => -
    .replace(/^-+|-+$/g, "");    // trim dashes
}
